module.exports = __webpack_public_path__ + "img/martini-glass.06898615.svg";